import {HTTP} from './common'

export const ReviewApi = {

  reviews_uniq(page, size, filters) {
    return HTTP.get(`dictionary/reviews_uniq/?page=${page}&size=${size}${filters?'&'+filters:''}`).then(response => {
      return response.data
    });
  },
  resource_list() {
    return HTTP.get(`dictionary/reviews_stat/resource_list/`).then(response => {
      return response.data
    });
  },
  review_info() {
    return HTTP.get(`dictionary/reviews_stat/review_info/`).then(response => {
      return response.data
    });
  },
  resource_stat(start_date, end_date) {
    return HTTP.get(`dictionary/reviews_stat/resource_stat/?start_date=${start_date||""}&end_date=${end_date||""}`).then(response => {
      return response.data
    });
  },
  tone_stat(start_date, end_date) {
    return HTTP.get(`dictionary/reviews_stat/tone_stat/?start_date=${start_date||""}&end_date=${end_date||""}`).then(response => {
      return response.data
    });
  },
  answer_stat(start_date) {
    return HTTP.get(`dictionary/reviews_stat/answer_stat/?date=${start_date||""}`).then(response => {
      return response.data
    });
  },
  rating_graph(period, start_date, end_date) {
    return HTTP.get(`dictionary/reviews_stat/rating_graph/?period=${period||""}&start_date=${start_date||""}&end_date=${end_date||""}`).then(response => {
      return response.data
    });
  },

  tone_graph(period, start_date, end_date) {
    return HTTP.get(`dictionary/reviews_stat/tone_graph/?period=${period||""}&start_date=${start_date||""}&end_date=${end_date||""}`).then(response => {
      return response.data
    });
  }


};

